import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowUpRight,
  MessageCircle,
  Check as CheckIcon,
  Flame,
  Truck,
  Zap,
  Droplet,
  Waves,
  Bug,
  Paintbrush,
  Hammer,
  Scale,
  Stethoscope,
  Smile,
  Brain,
  HeartPulse,
  BatteryCharging,
  Cog,
  Car,
  Sparkles,
  Scissors,
  Dumbbell,
  Home as HomeIcon,
  Key,
  Trees,
  Square,
  Layers,
  Shield,
  Wrench,
  Snowflake,
  Flame as FlameIcon,
  Package,
  Briefcase,
  User,
  Users,
  Smartphone,
  Monitor,
  Tablet,
  Laptop,
  Wifi,
  Search as SearchIcon,
  Lock,
  Globe,
  Phone as PhoneIcon,
  MapPin,
  Rocket,
  Rss,
  Palette,
  Headphones,
  ThumbsUp,
  Award,
  Target,
  Star,
} from "lucide-react";
import PageHero from "../components/PageHero";
import { Section, Eyebrow, SectionHeading, Check } from "../components/SectionPrimitives";
import {
  LaptopFrame,
  MonitorFrame,
  TabletFrame,
  PhoneFrame,
} from "../components/DeviceMockups";
import { waUrl } from "../lib/site";

const WA_MSG =
  "Olá! Vim pelo site e quero solicitar um orçamento para o Site Profissional a partir de R$ 249,90.";

const services = [
  { label: "Guincho 24 Horas", icon: Truck },
  { label: "Eletricistas", icon: Zap },
  { label: "Encanadores", icon: Wrench },
  { label: "Desentupidoras", icon: Waves },
  { label: "Dedetizadoras", icon: Bug },
  { label: "Pintores", icon: Paintbrush },
  { label: "Pedreiros", icon: Hammer },
  { label: "Advogados", icon: Scale },
  { label: "Médicos", icon: Stethoscope },
  { label: "Dentistas", icon: Smile },
  { label: "Psicólogos", icon: Brain },
  { label: "Clínicas", icon: HeartPulse },
  { label: "Auto Elétricas", icon: BatteryCharging },
  { label: "Mecânicas", icon: Cog },
  { label: "Lava Car", icon: Car },
  { label: "Estéticas", icon: Sparkles },
  { label: "Salões de Beleza", icon: Scissors },
  { label: "Barbearias", icon: Scissors },
  { label: "Personal Trainer", icon: Dumbbell },
  { label: "Academias", icon: Dumbbell },
  { label: "Imobiliárias", icon: HomeIcon },
  { label: "Corretores", icon: Key },
  { label: "Empresas de Limpeza", icon: Sparkles },
  { label: "Jardineiros", icon: Trees },
  { label: "Piscineiros", icon: Droplet },
  { label: "Vidraçarias", icon: Square },
  { label: "Marmorarias", icon: Layers },
  { label: "Marcenarias", icon: Hammer },
  { label: "Serralherias", icon: Wrench },
  { label: "Empresas de Segurança", icon: Shield },
  { label: "Assistência Técnica", icon: Wrench },
  { label: "Ar Condicionado", icon: Snowflake },
  { label: "Gás e Água", icon: FlameIcon },
  { label: "Transportadoras", icon: Truck },
  { label: "Mudanças", icon: Package },
  { label: "Pequenas Empresas", icon: Briefcase },
  { label: "Autônomos", icon: User },
  { label: "Prestadores em Geral", icon: Users },
];

const benefits = [
  { label: "Site 100% Responsivo", icon: Smartphone },
  { label: "Integração com WhatsApp", icon: MessageCircle },
  { label: "Google Maps Integrado", icon: MapPin },
  { label: "Botões de Ligação Direta", icon: PhoneIcon },
  { label: "Formulário de Contato", icon: Rss },
  { label: "Hospedagem Rápida", icon: Rocket },
  { label: "Certificado SSL (Site Seguro)", icon: Lock },
  { label: "Domínio Próprio", icon: Globe },
  { label: "Layout Moderno", icon: Palette },
  { label: "Otimizado para Google (SEO)", icon: SearchIcon },
  { label: "Carregamento Ultra Rápido", icon: Zap },
  { label: "Fácil de Atualizar", icon: Wifi },
];

const differentials = [
  { label: "Atendimento Rápido", desc: "Retorno em minutos pelo WhatsApp.", icon: Headphones, color: "#4285F4" },
  { label: "Desenvolvimento Profissional", desc: "Código limpo, moderno e otimizado.", icon: Cog, color: "#EA4335" },
  { label: "Entrega em Poucos Dias", desc: "Seu site no ar em até 2 dias úteis.", icon: Rocket, color: "#FBBC05" },
  { label: "Design Exclusivo", desc: "Nada de template genérico — cada projeto é único.", icon: Palette, color: "#34A853" },
  { label: "Suporte Especializado", desc: "Time técnico disponível quando você precisar.", icon: ThumbsUp, color: "#4285F4" },
  { label: "Excelente Custo-Benefício", desc: "Preço justo, valor entregue muito maior.", icon: Award, color: "#EA4335" },
  { label: "+100 Sites Desenvolvidos", desc: "Portfólio comprovado em dezenas de segmentos.", icon: Target, color: "#FBBC05" },
  { label: "Foco em Gerar Clientes", desc: "Cada elemento pensado para converter visitas em vendas.", icon: MessageCircle, color: "#34A853" },
];

const colorRotate = ["#4285F4", "#EA4335", "#FBBC05", "#34A853"];

const siteTestimonials = [
  {
    name: "Carlos Henrique",
    role: "Guincho 24 Horas",
    text: "Ficou muito acima das minhas expectativas. O site passou muito mais credibilidade e comecei a receber contatos pelo Google e WhatsApp logo após a publicação. Recomendo!",
  },
  {
    name: "Fernanda Oliveira",
    role: "Clínica de Estética",
    text: "Atendimento excelente e entrega super rápida. O site ficou lindo, moderno e funciona perfeitamente no celular. Valeu muito o investimento.",
  },
  {
    name: "Marcos Silva",
    role: "Eletricista",
    text: "Precisava de um site simples, profissional e com bom custo-benefício. Ficou exatamente como eu queria e meus clientes elogiam bastante.",
  },
  {
    name: "Juliana Costa",
    role: "Psicóloga",
    text: "Gostei muito da organização do site e da facilidade para os pacientes entrarem em contato pelo WhatsApp. Trabalho impecável.",
  },
  {
    name: "Ricardo Souza",
    role: "Dedetizadora",
    text: "Além de bonito, o site carrega muito rápido e transmite confiança para os clientes. O suporte também foi excelente.",
  },
  {
    name: "Patrícia Mendes",
    role: "Advogada",
    text: "Desde que publiquei o site, minha presença online melhorou bastante. Atendimento atencioso e entrega dentro do prazo.",
  },
  {
    name: "Eduardo Martins",
    role: "Encanador",
    text: "Ótimo custo-benefício. O processo foi rápido, sem complicação, e o resultado ficou muito profissional.",
  },
  {
    name: "Aline Ferreira",
    role: "Salão de Beleza",
    text: "Minha agenda aumentou depois que comecei a divulgar o site nas redes sociais. Ficou elegante, rápido e muito fácil de navegar.",
  },
];

export default function SiteProfissional() {
  return (
    <div data-testid="page-site-profissional">
      {/* HERO — Dark like Home */}
      <section
        data-testid="hero-site-prof"
        className="relative overflow-hidden bg-[#000000] text-white"
      >
        <div
          aria-hidden
          className="pointer-events-none absolute -top-32 -right-40 w-[520px] h-[520px] rounded-full opacity-[0.15] blur-3xl"
          style={{ background: "#34A853" }}
        />
        <div
          aria-hidden
          className="pointer-events-none absolute bottom-0 left-0 w-[420px] h-[420px] rounded-full opacity-[0.10] blur-3xl"
          style={{ background: "#4285F4" }}
        />

        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-20 sm:pt-20 sm:pb-24 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7 reveal">
            <span
              data-testid="hero-price-badge"
              className="inline-flex items-center gap-2 bg-[#EA4335] text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-full text-[10px] sm:text-sm font-bold tracking-[0.1em] sm:tracking-[0.15em] uppercase shadow-lg animate-pulse max-w-full"
              style={{ boxShadow: "0 10px 30px -8px rgba(234,67,53,.7)" }}
            >
              <Flame size={14} className="animate-bounce shrink-0" />
              <span className="whitespace-normal sm:whitespace-nowrap">
                Oferta Especial — R$ 249,90
              </span>
            </span>

            <h1 className="mt-8 font-display text-4xl sm:text-5xl lg:text-7xl font-bold tracking-tighter text-white leading-[0.98]">
              Seu site profissional a partir de{" "}
              <span className="text-[#34A853] whitespace-nowrap">R$ 249,90</span>
            </h1>

            <p className="mt-8 text-base sm:text-lg text-white/70 leading-relaxed max-w-xl">
              Conquiste mais clientes, transmita credibilidade e apareça no
              Google com um site{" "}
              <strong className="text-white">
                moderno, rápido e responsivo
              </strong>
              . Desenvolvido para empresas e prestadores de serviços que
              querem vender mais na internet.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href={waUrl(WA_MSG)}
                target="_blank"
                rel="noreferrer"
                data-testid="hero-wa-cta"
                className="inline-flex items-center justify-center gap-2 bg-[#34A853] text-white px-7 py-4 font-medium hover:bg-[#2c8f47] transition rounded-md text-base sm:text-lg"
              >
                <MessageCircle size={20} />
                Solicitar Orçamento no WhatsApp
              </a>
              <Link
                to="#preco"
                data-testid="hero-preco-cta"
                className="inline-flex items-center justify-center gap-2 border border-white/30 text-white px-7 py-4 font-medium hover:bg-white hover:text-[#000000] transition rounded-md"
              >
                Ver oferta
                <ArrowUpRight size={18} />
              </Link>
            </div>

            {/* Mini device row */}
            <div className="mt-12 flex flex-wrap items-center gap-x-6 gap-y-3 text-white/50 text-xs uppercase tracking-[0.15em]">
              <span className="flex items-center gap-2"><Laptop size={16}/> Notebook</span>
              <span className="flex items-center gap-2"><Monitor size={16}/> Desktop</span>
              <span className="flex items-center gap-2"><Tablet size={16}/> Tablet</span>
              <span className="flex items-center gap-2"><Smartphone size={16}/> Mobile</span>
            </div>
          </div>

          {/* HERO — Price card (same style as pricing section) */}
          <div className="lg:col-span-5 relative reveal" style={{ animationDelay: ".15s" }}>
            <div
              data-testid="hero-preco-card"
              className="relative border-2 border-[#34A853] bg-white/[0.04] backdrop-blur-sm p-6 sm:p-10 rounded-2xl shadow-2xl"
              style={{ boxShadow: "0 30px 60px -20px rgba(52,168,83,.35)" }}
            >
              <div className="absolute -top-4 left-6 sm:left-8 bg-[#EA4335] text-white text-[10px] sm:text-xs uppercase tracking-widest font-bold px-3 sm:px-4 py-2 rounded flex items-center gap-2 animate-pulse">
                <Flame size={14} />
                Oferta Especial
              </div>

              <p className="eyebrow text-white/60 mt-2">Plano Essencial</p>
              <h3 className="font-display text-2xl sm:text-3xl font-bold text-white mt-3">
                Site Profissional
              </h3>

              <div className="mt-5 inline-flex items-center gap-2 bg-[#34A853]/15 border border-[#34A853]/40 text-[#34A853] px-3 py-1.5 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-widest">
                <CheckIcon size={12} strokeWidth={3} />
                Pagamento único
              </div>

              <div className="mt-6 flex items-end gap-2">
                <span className="text-white/60 text-xl sm:text-2xl font-display font-medium">
                  A partir de
                </span>
              </div>
              <div className="flex items-baseline gap-2 mt-2">
                <span className="text-white/80 text-2xl sm:text-3xl font-display font-bold">
                  R$
                </span>
                <span className="big-number text-6xl sm:text-7xl lg:text-8xl text-white leading-none">
                  249
                </span>
                <span className="text-white/80 text-2xl sm:text-3xl font-display font-bold">
                  ,90
                </span>
              </div>

              <p className="mt-3 text-sm text-white/70 leading-relaxed">
                Pago <strong className="text-white">apenas uma única vez</strong>.
                Sem mensalidades, sem anuidades. O site é seu, para sempre.
              </p>

              <a
                href={waUrl(WA_MSG)}
                target="_blank"
                rel="noreferrer"
                data-testid="hero-preco-wa"
                className="mt-6 w-full inline-flex items-center justify-center gap-3 bg-[#34A853] text-white px-6 py-4 sm:py-5 font-bold text-base sm:text-lg hover:bg-[#2c8f47] transition rounded-md"
              >
                <MessageCircle size={20} />
                QUERO MEU SITE
              </a>

              <p className="mt-4 text-center text-xs text-white/50">
                Resposta em minutos • Sem compromisso
              </p>
            </div>
          </div>
        </div>

        <div className="g-stripe" />
      </section>

      {/* SUB-HEADLINE */}
      <Section testId="site-prof-subheadline" className="!py-16 border-b border-gray-100">
        <div className="max-w-4xl">
          <Eyebrow color="#34A853">Feito para vender</Eyebrow>
          <p className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-[#000000] tracking-tighter leading-[1.15]">
            Desenvolvemos sites profissionais para{" "}
            <span className="g-underline">empresas e prestadores de serviços</span>{" "}
            que desejam vender mais na internet.
          </p>
        </div>
      </Section>

      {/* MOCKUPS SECTION — Live device previews of our own site */}
      <Section testId="site-prof-mockups" className="bg-[#F8F9FA] border-b border-gray-100">
        <SectionHeading
          eyebrow="Mockups Reais"
          title="Veja como fica em cada dispositivo."
          subtitle="Cada projeto é desenvolvido pensando em todas as telas — do celular ao monitor 4K, seu site é rápido e lindo em qualquer lugar. Os exemplos abaixo mostram nosso próprio site rodando em cada dispositivo."
        />
        <div className="grid lg:grid-cols-12 gap-10 items-center" data-testid="mockup-grid">
          {/* Laptop — big center */}
          <div
            className="lg:col-span-8 relative"
            data-testid="mockup-laptop"
          >
            <div className="flex items-center gap-2 mb-4">
              <Laptop size={18} className="text-[#4285F4]" />
              <span className="text-xs uppercase tracking-[0.2em] text-[#000000]/60">
                Notebook — Home
              </span>
              <span className="ml-2 h-[2px] w-12 bg-[#4285F4]" />
            </div>
            <LaptopFrame src="/" title="Preview: Home" />
          </div>

          {/* Phone — side */}
          <div className="lg:col-span-4" data-testid="mockup-phone">
            <div className="flex items-center gap-2 mb-4">
              <Smartphone size={18} className="text-[#34A853]" />
              <span className="text-xs uppercase tracking-[0.2em] text-[#000000]/60">
                Mobile — Site R$ 249
              </span>
              <span className="ml-2 h-[2px] w-12 bg-[#34A853]" />
            </div>
            <PhoneFrame src="/site-profissional" title="Preview: Site R$ 249" />
          </div>

          {/* Monitor — full width */}
          <div className="lg:col-span-7" data-testid="mockup-desktop">
            <div className="flex items-center gap-2 mb-4">
              <Monitor size={18} className="text-[#EA4335]" />
              <span className="text-xs uppercase tracking-[0.2em] text-[#000000]/60">
                Desktop / iMac — Google Ads
              </span>
              <span className="ml-2 h-[2px] w-12 bg-[#EA4335]" />
            </div>
            <MonitorFrame src="/google-ads" title="Preview: Google Ads" />
          </div>

          {/* Tablet */}
          <div className="lg:col-span-5" data-testid="mockup-tablet">
            <div className="flex items-center gap-2 mb-4">
              <Tablet size={18} className="text-[#FBBC05]" />
              <span className="text-xs uppercase tracking-[0.2em] text-[#000000]/60">
                Tablet — Criação de Sites
              </span>
              <span className="ml-2 h-[2px] w-12 bg-[#FBBC05]" />
            </div>
            <TabletFrame src="/criacao-de-sites" title="Preview: Criação de Sites" />
          </div>
        </div>
      </Section>

      {/* FAZEMOS SITES PARA */}
      <Section testId="site-prof-services">
        <SectionHeading
          eyebrow="Fazemos Sites Para"
          title="Do prestador autônomo à pequena empresa."
          subtitle="Mais de 38 segmentos atendidos. Independentemente da sua área, sabemos como construir um site que gera clientes de verdade."
        />
        <div
          data-testid="services-grid"
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-gray-100 border border-gray-100"
        >
          {services.map((s, i) => {
            const Icon = s.icon;
            const color = colorRotate[i % 4];
            return (
              <div
                key={s.label}
                data-testid={`service-item-${i}`}
                className="bg-white p-5 sm:p-6 flex items-center gap-3 hover:bg-[#F8F9FA] transition group"
              >
                <span
                  className="w-9 h-9 shrink-0 inline-flex items-center justify-center rounded"
                  style={{ background: color + "15" }}
                >
                  <Icon size={18} style={{ color }} />
                </span>
                <p className="font-medium text-[#000000] text-sm leading-tight">
                  {s.label}
                </p>
              </div>
            );
          })}
        </div>
        <div className="text-center mt-12">
          <a
            href={waUrl("Olá! Sou prestador de serviços e quero um site profissional.")}
            target="_blank"
            rel="noreferrer"
            data-testid="services-wa-cta"
            className="btn-whatsapp inline-flex"
          >
            <MessageCircle size={18} />
            Não achou seu segmento? Fale conosco
          </a>
        </div>
      </Section>

      {/* BENEFÍCIOS */}
      <Section testId="site-prof-benefits" className="bg-[#F8F9FA] border-y border-gray-100">
        <SectionHeading
          eyebrow="Benefícios"
          title="Tudo o que seu site precisa — já incluso."
          subtitle="Nada de surpresa. Cada projeto vem completo, do domínio à otimização para o Google."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {benefits.map((b, i) => {
            const Icon = b.icon;
            const color = colorRotate[i % 4];
            return (
              <div
                key={b.label}
                data-testid={`benefit-${i}`}
                className="bg-white border border-gray-100 p-5 flex items-center gap-4 hover:-translate-y-1 hover:shadow-lg transition"
              >
                <span
                  className="w-11 h-11 shrink-0 inline-flex items-center justify-center rounded-lg"
                  style={{ background: color + "15" }}
                >
                  <Icon size={20} style={{ color }} />
                </span>
                <div className="flex items-center gap-2 flex-1">
                  <CheckIcon size={16} style={{ color: "#34A853" }} className="shrink-0" />
                  <p className="font-medium text-[#000000] leading-tight">
                    {b.label}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </Section>

      {/* DIFERENCIAIS */}
      <Section testId="site-prof-differentials">
        <SectionHeading
          eyebrow="Por que escolher nossa empresa?"
          title="Qualidade profissional com atendimento humano."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-gray-100 border border-gray-100">
          {differentials.map((d, i) => {
            const Icon = d.icon;
            return (
              <div
                key={d.label}
                data-testid={`differential-${i}`}
                className="bg-white p-7 relative hover:bg-[#F8F9FA] transition"
              >
                <div
                  className="absolute top-0 left-0 w-10 h-[3px]"
                  style={{ background: d.color }}
                />
                <Icon size={26} style={{ color: d.color }} />
                <h3 className="font-display text-lg font-bold text-[#000000] mt-5">
                  {d.label}
                </h3>
                <p className="mt-2 text-sm text-[#000000]/70 leading-relaxed">
                  {d.desc}
                </p>
              </div>
            );
          })}
        </div>
      </Section>

      {/* AVALIAÇÕES */}
      <Section testId="site-prof-testimonials" className="bg-[#F8F9FA] border-y border-gray-100">
        <SectionHeading
          eyebrow="Avaliações Reais"
          title="O que dizem quem já contratou."
          subtitle="Empresas e prestadores de serviços de todo o Brasil que confiaram na O.G. para colocar seu negócio na internet."
        />
        <div className="flex items-center gap-6 mb-10">
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((s) => (
              <Star key={s} size={22} className="fill-[#FBBC05] text-[#FBBC05]" />
            ))}
          </div>
          <div className="border-l border-gray-300 pl-6">
            <p className="font-display text-3xl font-bold text-[#000000]">5.0/5</p>
            <p className="text-xs text-[#000000]/60">Média de satisfação</p>
          </div>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {siteTestimonials.map((t, i) => (
            <article
              key={t.name}
              data-testid={`site-testimonial-${i}`}
              className="bg-white border border-gray-100 p-6 relative hover:-translate-y-1 hover:shadow-lg transition"
              style={{ borderTop: `3px solid ${colorRotate[i % 4]}` }}
            >
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((s) => (
                  <Star key={s} size={12} className="fill-[#FBBC05] text-[#FBBC05]" />
                ))}
              </div>
              <p className="text-sm text-[#000000]/80 leading-relaxed">
                {`"${t.text}"`}
              </p>
              <div className="mt-5 pt-4 border-t border-gray-100">
                <p className="font-display font-bold text-[#000000] text-sm">{t.name}</p>
                <p className="text-xs text-[#000000]/60 mt-1">{t.role}</p>
              </div>
            </article>
          ))}
        </div>
      </Section>
      <Section testId="site-prof-preco" className="bg-[#000000] text-white relative">
        <div id="preco" className="absolute -top-24" />
        <div
          aria-hidden
          className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full opacity-[0.08] blur-3xl"
          style={{ background: "#34A853" }}
        />
        <div className="relative grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-2 border border-[#FBBC05]/50 bg-[#FBBC05]/10 px-4 py-2 rounded-full text-[11px] tracking-[0.25em] uppercase text-[#FBBC05] font-medium">
              <Flame size={14} />
              Oferta Especial
            </span>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.02]">
              Site Profissional a partir de{" "}
              <span className="text-[#34A853]">R$ 249,90</span>
            </h2>
            <p className="mt-6 text-white/70 leading-relaxed text-lg max-w-xl">
              Ideal para quem deseja começar a vender pela internet. Um site
              completo, entregue em poucos dias, com tudo o que sua empresa
              precisa para atrair clientes hoje mesmo.
            </p>
            <ul className="mt-8 space-y-3">
              {[
                "Pagamento único — sem mensalidade, sem anuidade",
                "O site é 100% seu, no seu nome e CNPJ",
                "Site completo e responsivo",
                "Domínio + hospedagem + SSL inclusos*",
                "Integração com WhatsApp",
                "Entrega em até 2 dias úteis",
                "Suporte especializado",
              ].map((li) => (
                <li key={li} className="flex items-start gap-3 text-white/85">
                  <span className="mt-1 inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#34A853] shrink-0">
                    <CheckIcon size={12} className="text-white" strokeWidth={3} />
                  </span>
                  {li}
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-white/40">
              * Domínio e hospedagem inclusos no primeiro ano. Após esse período,
              você renova diretamente com o provedor — nenhum valor é cobrado por
              nós.
            </p>
          </div>

          {/* Price card */}
          <div className="lg:col-span-6">
            <div
              data-testid="preco-card"
              className="relative border-2 border-[#34A853] bg-white/[0.04] backdrop-blur-sm p-8 sm:p-12 rounded-2xl"
            >
              <div className="absolute -top-4 left-8 bg-[#EA4335] text-white text-xs uppercase tracking-widest font-medium px-4 py-2 rounded flex items-center gap-2">
                <Flame size={14} />
                Oferta Especial
              </div>

              <p className="eyebrow text-white/60 mt-2">Plano Essencial</p>
              <h3 className="font-display text-2xl sm:text-3xl font-bold text-white mt-3">
                Site Profissional
              </h3>

              <div className="mt-6 inline-flex items-center gap-2 bg-[#34A853]/15 border border-[#34A853]/40 text-[#34A853] px-3 py-1.5 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-widest">
                <CheckIcon size={12} strokeWidth={3} />
                Pagamento único
              </div>

              <div className="mt-6 flex items-end gap-2">
                <span className="text-white/60 text-xl sm:text-2xl font-display font-medium">
                  A partir de
                </span>
              </div>
              <div className="flex items-baseline gap-2 mt-2">
                <span className="text-white/80 text-3xl font-display font-bold">R$</span>
                <span className="big-number text-7xl sm:text-8xl text-white leading-none">
                  249
                </span>
                <span className="text-white/80 text-3xl font-display font-bold">
                  ,90
                </span>
              </div>

              <p className="mt-3 text-sm text-white/70 leading-relaxed">
                Pago <strong className="text-white">apenas uma única vez</strong>.
                Sem mensalidades, sem anuidades. O site é seu, para sempre.
              </p>

              <a
                href={waUrl(WA_MSG)}
                target="_blank"
                rel="noreferrer"
                data-testid="preco-wa-cta"
                className="mt-8 w-full inline-flex items-center justify-center gap-3 bg-[#34A853] text-white px-8 py-5 font-bold text-lg hover:bg-[#2c8f47] transition rounded-md"
              >
                <MessageCircle size={22} />
                QUERO MEU SITE
              </a>

              <p className="mt-4 text-center text-xs text-white/50">
                Resposta em minutos • Sem compromisso
              </p>
            </div>
          </div>
        </div>
      </Section>

      {/* CTA FINAL */}
      <Section testId="site-prof-final-cta" className="bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <Eyebrow color="#EA4335">
            <span className="mx-auto">Última chance</span>
          </Eyebrow>
          <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-6xl font-bold tracking-tighter text-[#000000] leading-[1.05]">
            Pare de perder clientes para seus{" "}
            <span className="g-underline">concorrentes.</span>
          </h2>
          <p className="mt-6 text-lg text-[#000000]/70 leading-relaxed">
            Tenha hoje mesmo um site profissional que transmite confiança e
            ajuda sua empresa a vender mais. Sem burocracia, sem enrolação.
          </p>
          <a
            href={waUrl(WA_MSG)}
            target="_blank"
            rel="noreferrer"
            data-testid="final-cta-wa"
            className="mt-10 inline-flex items-center justify-center gap-3 bg-[#34A853] text-white px-10 py-6 font-bold text-lg sm:text-xl hover:bg-[#2c8f47] transition rounded-md shadow-xl"
            style={{ boxShadow: "0 20px 40px -12px rgba(52,168,83,.4)" }}
          >
            <MessageCircle size={24} />
            QUERO MEU SITE
          </a>
          <p className="mt-4 text-sm text-[#000000]/50">
            Fale com nosso time no WhatsApp — resposta em minutos.
          </p>
        </div>
      </Section>
    </div>
  );
}
